module.exports = __webpack_public_path__ + "static/media/social-cta.80d57361.jpg";